import "./App.css";
import Header from "./components/Header/Header";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import ChooseCountry from "components/content/ChooseCountry/ChooseCountry";
import SilencingPage from "components/content/SilencingPage/SilencingPage";
import ArticleDownload from "components/content/ArticleDownload/ArticleDownload";
import OpenLinkContainer from "components/content/OpenLink/OpenLinkContainer";
import ArticleCodeMPContainer from "components/content/ArticleCodeMP/ArticleCodeMPContainer";
import CountryPlugs from "components/content/CountryPlugs/Country Plugs";
import CreateArticle from "components/content/createArticle/CreateArticle";
import ListArticle from "components/content/listArticle/ListArticle";
import ViewArticle from "components/content/viewArticle/ViewArticle";
import ArticleForUser from "components/content/articleForUser/ArticleForUser";
import HTMLArticleViewer from "components/content/htmlArticle/HTMLArticleViewer";
import MPArticlePage from "components/content/MPArticlePage";
import Login from "components/content/login/Login";
import { MainLayout } from "components/common/common";
import ProtectedRoute from "./ProtectedRoute";
import PaymentSuccess from "components/content/paymentsResult/PaymentSuccess";
import PaymentFailed from "components/content/paymentsResult/PaymentFailed";
import Redirect from "components/content/redirect/Redirect";
import RedirectForUser from "components/content/redirect/RedirectForUser";

import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
      <div>
        <Router>
          <Routes>
            {/* Маршруты с Header и main контейнером */}
            <Route
              path="/*"
              element={
                <div className="App">
                  <div className="header">
                    <Header />
                  </div>
                  <div className="main">
                    <Routes>
                      <Route
                        path="/"
                        element={<ChooseCountry />}
                      />
                      <Route
                        path="*"
                        element={<SilencingPage />}
                      />
                      <Route
                        path="/app"
                        element={<ArticleDownload />}
                      />
                      <Route
                        path="/open"
                        element={<OpenLinkContainer />}
                      />
                      <Route
                        path="/mp"
                        element={<ArticleCodeMPContainer />}
                      />
                      <Route
                        path="/mp/:code_mp"
                        element={<MPArticlePage />}
                      />
                      <Route
                        path="/mp/:id"
                        element={<ArticleCodeMPContainer />}
                      />
                      <Route
                        path="/country/:id"
                        element={<CountryPlugs />}
                      />
                      <Route
                        path="/payment/success"
                        element={<PaymentSuccess />}
                      />
                      <Route
                        path="/payment/failed"
                        element={<PaymentFailed />}
                      />
                    </Routes>
                  </div>
                </div>
              }
            />

            {/* Маршруты без Header и main контейнера */}
            <Route
              path="/admin/login"
              element={<Login />}
            />

            {/* Маршруты с Articles контейнером */}
            <Route
              path="/admin/*"
              element={
                <div className="Articles">
                  <ProtectedRoute>
                    <MainLayout />
                  </ProtectedRoute>
                </div>
              }
            >
              <Route
                path="articles"
                element={<ListArticle />}
              />
              <Route
                path="articles/create"
                element={<CreateArticle />}
              />
              <Route
                path="articles/:hash"
                element={<ViewArticle />}
              />
              <Route
                path="articles/edit/:hash"
                element={<CreateArticle />}
              />
              <Route
                path="redirects"
                element={<Redirect />}
              />
              <Route
                index
                element={
                  <Navigate
                    to="articles"
                    replace
                  />
                }
              />
            </Route>

            {/* Маршруты для статей и редиректов без оберток */}
            <Route
              path="/art/:hash"
              element={<ArticleForUser />}
            />
            <Route
              path="/info/:hash"
              element={<HTMLArticleViewer />}
            />
            <Route
              path="/dir/:id"
              element={<RedirectForUser />}
            />
          </Routes>
        </Router>
      </div>
    </HelmetProvider>
  );
}

export default App;
